/**
 * Kapsamlı Kota Dağıt sonucu → uyarı mesajı (#386, sözleşme
 * firm-quota-distribute-scope.md). Sunucu cevabı: { distributed, busy, skipped }.
 */
export const distributeResultAlert = (result = {}) => {
  const distributed = result.distributed || [];
  const busy = result.busy || [];
  const busyNames = busy.map((f) => f.firmName).filter(Boolean).join(", ");
  const busyText = busy.length > 0 ? ` Meşgul olduğu için atlanan: ${busyNames || `${busy.length} firma`}.` : "";

  if (distributed.length === 0) {
    return {
      severity: busy.length > 0 ? "warning" : "info",
      message: busy.length > 0 ? `Kota dağıtılamadı.${busyText}` : "Dağıtılacak kota bulunamadı.",
    };
  }
  const head =
    distributed.length === 1 ? "Kota dağıtımı başarıyla tamamlandı." : `${distributed.length} firmada kota dağıtıldı.`;
  return { severity: busy.length > 0 ? "warning" : "success", message: head + busyText };
};
